import { Alert, Box, Link, Text } from '@nimbus-ds/components';

interface InvoiceSectionProps {
  readonly title: string;
  readonly errorTitle?: string;
  readonly xmlUrl?: string;
  readonly pdfUrl?: string;
  readonly errorMessage?: string[];
  readonly t: any;
}

function InvoiceSection({
  title,
  errorTitle,
  xmlUrl,
  pdfUrl,
  errorMessage,
  t,
}: InvoiceSectionProps) {
  return (
    <Box marginBottom="2">
      <Box display="flex" alignItems="center" gap="2" marginBottom="1">
        <Text color="neutral-textHigh">{title}</Text>

        {(!!xmlUrl || !!pdfUrl) && (
          <>
            {!!xmlUrl && (
              <Link
                as="a"
                href={xmlUrl}
                target="_blank"
                appearance="primary"
                textDecoration="none"
              >
                {t('cardInvoice.link.xml')}
              </Link>
            )}
            {!!xmlUrl && !!pdfUrl && <Text as="span">-</Text>}
            {!!pdfUrl && (
              <Link
                as="a"
                href={pdfUrl}
                target="_blank"
                appearance="primary"
                textDecoration="none"
              >
                {t('cardInvoice.link.pdf')}
              </Link>
            )}
          </>
        )}
      </Box>

      {!!errorMessage && errorMessage.length > 0 && (
        <Alert title={errorTitle} appearance="danger" show>
          <Box>
            {errorMessage.map((msg, i) => (
              <Text
                key={`${msg.slice(0, 10)}-${i}`}
                fontSize="base"
                fontWeight="regular"
              >
                {msg}
              </Text>
            ))}
          </Box>
        </Alert>
      )}
    </Box>
  );
}

export default InvoiceSection;
